export default __webpack_public_path__ + "static/media/brahmdhamtirth-logo.f92a4b61.jpeg";